export function resolveCameraProximityOpacity(args) {
    const { proximity, fade } = args;
    if (proximity.inside)
        return fade.insideOpacity ?? fade.nearOpacity;
    if (proximity.distance <= fade.nearDistance)
        return fade.nearOpacity;
    if (proximity.distance >= fade.farDistance)
        return 1;
    const progress = (proximity.distance - fade.nearDistance) / (fade.farDistance - fade.nearDistance);
    return fade.nearOpacity + (1 - fade.nearOpacity) * progress;
}
/** Proximity to a bounding sphere; the fallback for shapes without an exact volume. */
export function resolveSphereCameraProximity(args) {
    const centerDistance = Math.hypot(args.camera[0] - args.center[0], args.camera[1] - args.center[1], args.camera[2] - args.center[2]);
    return {
        distance: Math.max(0, centerDistance - args.radius),
        inside: centerDistance <= args.radius,
    };
}
/** Proximity to a cylinder volume centred on the origin with its axis on +Y, from a camera in that frame. */
export function resolveCylinderCameraProximity(args) {
    const [x, y, z] = args.cameraLocal;
    const radialExcess = Math.max(0, Math.hypot(x, z) - args.radius);
    const axialExcess = Math.max(0, Math.abs(y) - args.height / 2);
    return {
        distance: Math.hypot(radialExcess, axialExcess),
        inside: radialExcess === 0 && axialExcess === 0,
    };
}
/** Yaw about +Y that turns a half wall spanning +X to face away from a camera in the wall's frame. */
export function resolveCutawayYaw(cameraLocal) {
    return Math.atan2(cameraLocal[2], -cameraLocal[0]);
}
